import { isEmpty } from 'lodash'

const dietImageFormInitialValues = values => ({
  id: values.id,
  image: isEmpty(values.imageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.imageUrl }],
  onboardingImage: isEmpty(values.onboardingImageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.onboardingImageUrl }],
})

export default dietImageFormInitialValues
